/*================ Shopify Common JS ================*/
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  } 
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

Shopify.formatMoney = function(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

/*================ Helper Functions ================*/
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

function setCookie(name, value, days) {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function slideUp(target, duration = 500) {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
  }, duration);
}

function slideDown(target, duration = 500) {
  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout( () => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}

function slideToggle(target, duration = 500) {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
}

function fadeIn(target, duration = 500) {
  target.style.display = '';
  target.style.opacity = 0;
  var last = +new Date();
  var tick = function() {
    target.style.opacity = +target.style.opacity + (new Date() - last) / duration;
    last = +new Date();
    if (+target.style.opacity < 1) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
    }
  };
  tick();
}

function fadeOut(target, duration = 500) {
  target.style.display = '';
  target.style.opacity = 1;
  let last = +new Date();
  let tick = function() {
    target.style.opacity = Number(+target.style.opacity - (new Date() - last) / duration).toFixed(4);
    last = +new Date();
    if (-target.style.opacity <= 0) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
    } else{
        target.style.opacity = 0;
    }
  };
  tick();
}

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

function atcGetSectionsToRender() {
  return [
    {
      id: 'cart-drawer__content',
      section: document.getElementById('cart-drawer__content').dataset.id,
      selector: '.cart-drawer__content',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    },
    {
      id: 'cart-upsell-price',
      section: 'main-product',
      selector: '.product-upsell__button .price'
    }
  ];
}

function addToCart(body, openCart = true, refresh) {
  fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
  .then((response) => response.json())
  .then((parsedState) => {
    if (!refresh) {
      atcGetSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
          getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
    }
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {
    if (openCart) {
      document.querySelector('cart-drawer').open();
    }

    if (refresh) {
      location.reload();
    }
  });
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

/*================ Initialize ================*/
// Micromodal
MicroModal.init({
  onShow: modal => {
    const video = modal.querySelector('video');
    if (video) {
      video.play();
    }
  },
  onClose: modal => {
    const video = modal.querySelector('video');
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  },
  openClass: 'is-open',
  disableScroll: true,
  disableFocus: true,
  awaitOpenAnimation: true,
  awaitCloseAnimation: true
});

// AOS
AOS.init({
  duration: 800
});

/*================ Components ================*/
var MenuDrawer = class extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.drawer = document.getElementById('menu-drawer');
    this.openButtons = document.querySelectorAll('.js-open-menu');
    this.closeButtons = document.querySelectorAll('.js-close-menu');
    this.menuButtons = document.querySelectorAll('.menu-drawer__menu-button');
    
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeMenuDrawer());
    this.bindEvents();
  }

  bindEvents() {
    this.openButtons.forEach(openBtn => openBtn.addEventListener('click', this.openMenuDrawer.bind(this)));
    this.closeButtons.forEach(closeBtn => closeBtn.addEventListener('click', this.closeMenuDrawer.bind(this)));
    this.menuButtons.forEach(menuBtn => menuBtn.addEventListener('click', this.toggleMenuButtons.bind(this)));
    this.onBodyClick = this.handleBodyClick.bind(this);
  }

  openMenuDrawer() {
    const fromTop = document.querySelector('.header').offsetHeight + document.querySelector('.header').getBoundingClientRect().top;
    this.drawer.style.top = `${fromTop - 1}px`;
    
    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);

    event.currentTarget.parentElement.setAttribute('data-aria-expanded', true);

    document.body.classList.add('scroll-lock');
  }

  closeMenuDrawer() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);

    event.currentTarget.parentElement.setAttribute('data-aria-expanded', false);

    document.body.classList.remove('scroll-lock');
  }

  toggleMenuButtons() {
    const parent = event.target.parentElement;
    const secondaryMenu = event.target.nextElementSibling;
    
    if (parent.classList.contains('is-open')) {
      slideUp(secondaryMenu);
      parent.classList.remove('is-open');
    } else {
      slideDown(secondaryMenu);
      parent.classList.add('is-open');
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList.contains('page-overlay')) {
      this.closeMenuDrawer();
      this.pageOverlayElement.classList.remove('is-visible');
    }
  }
}

customElements.define('menu-drawer', MenuDrawer);

var QuantityInput = class extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

var VariantSelects = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    const product = this.closest('.product');
    if (!product) return;

    const mediaList = product.querySelector('.product__media-list');
    const slides = Array.from(product.querySelectorAll('.product__media-item'));
    const thumbnails = Array.from(product.querySelectorAll('.product__media-thumbnail-item'));
    if (!slides.length) return;

    const variantData = this.getVariantData();
    const selectedOptions = (this.options || []).map((o) => String(o).toLowerCase().trim()).filter(Boolean);

    console.log('[updateMedia] Options:', selectedOptions);

    // Get featured media ID
    let featuredMediaId = null;
    if (this.currentVariant?.featured_media?.id) {
      featuredMediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
    }

    const shouldFilter = variantData.length > 1 && selectedOptions.length > 0;

    if (!shouldFilter) {
      // Show all, go to first
      slides.forEach(s => s.style.display = '');
      thumbnails.forEach(t => t.style.display = '');
      
      if (mediaList?.swiper) {
        mediaList.swiper.slideTo(0, 0);
        thumbnails.forEach(t => t.classList.remove('active'));
        thumbnails[0]?.classList.add('active');
      }
      return;
    }

    // ========== BUILD VISIBILITY MAP ==========
    const slideVisibility = slides.map((slide, index) => {
      const mediaId = slide.getAttribute('data-media-id');
      const alt = (slide.getAttribute('data-media-alt') || '').toLowerCase().trim();
      const hasAlt = alt.length > 0;
      
      const isFeatured = featuredMediaId && mediaId === featuredMediaId;
      const altMatches = hasAlt && selectedOptions.some(opt => alt.includes(opt));
      
      const visible = isFeatured || !hasAlt || altMatches;
      
      return {
        index,
        slide,
        visible,
        isFeatured,
        mediaId,
        alt
      };
    });

    // Find target slide
    let targetIndex = 0;
    const featuredSlide = slideVisibility.find(s => s.isFeatured && s.visible);
    if (featuredSlide) {
      targetIndex = featuredSlide.index;
    } else {
      const firstVisible = slideVisibility.find(s => s.visible);
      targetIndex = firstVisible ? firstVisible.index : 0;
    }

    console.log('[updateMedia] Target index:', targetIndex);
    console.log('[updateMedia] Visibility:', slideVisibility.map(s => `${s.index}:${s.visible}`));

    // ========== HIDE/SHOW SLIDES & THUMBNAILS ==========
    slideVisibility.forEach(({slide, visible, index}) => {
      slide.style.display = visible ? '' : 'none';
      if (thumbnails[index]) {
        thumbnails[index].style.display = visible ? '' : 'none';
      }
    });

    // ========== UPDATE SWIPER ==========
    if (mediaList?.swiper) {
      const swiper = mediaList.swiper;
      
      // Force Swiper to recalculate
      swiper.update();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      
      // Calculate real index (position among visible slides)
      const visibleSlides = slideVisibility.filter(s => s.visible);
      const targetInVisible = visibleSlides.findIndex(s => s.index === targetIndex);
      
      console.log('[updateMedia] Visible count:', visibleSlides.length);
      console.log('[updateMedia] Target in visible:', targetInVisible);
      
      // Go to slide
      const slideToIndex = targetInVisible !== -1 ? targetInVisible : 0;
      
      if (swiper.params.loop) {
        swiper.slideToLoop(slideToIndex, 0);
      } else {
        swiper.slideTo(slideToIndex, 0);
      }
      
      // Update thumbnails
      thumbnails.forEach(t => t.classList.remove('active'));
      if (thumbnails[targetIndex] && thumbnails[targetIndex].style.display !== 'none') {
        thumbnails[targetIndex].classList.add('active');
      }
      
      // ========== FIX THUMBNAIL CLICKS ==========
      thumbnails.forEach((thumb, thumbIndex) => {
        thumb.onclick = (e) => {
          e.preventDefault();
          
          if (thumb.style.display === 'none') return;
          
          // Find this thumbnail's position among visible thumbnails
          const visibleThumbs = thumbnails.filter(t => t.style.display !== 'none');
          const positionInVisible = visibleThumbs.indexOf(thumb);
          
          console.log(`[Thumb Click] DOM index ${thumbIndex}, visible position ${positionInVisible}`);
          
          if (positionInVisible !== -1) {
            if (swiper.params.loop) {
              swiper.slideToLoop(positionInVisible, 300);
            } else {
              swiper.slideTo(positionInVisible, 300);
            }
            
            thumbnails.forEach(t => t.classList.remove('active'));
            thumb.classList.add('active');
          }
        };
      });
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const destinationButton = document.getElementById(`price-${this.dataset.section}-atc`)
        const source = html.getElementById(id);
        

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationButton) destinationButton.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

var VariantRadios = class extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const selectedInputs = Array.from(fieldsets).map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
    });

    this.options = selectedInputs.map((input) => input.value);

    selectedInputs.forEach((input) => {
      const fieldset = input.closest('fieldset');
      const selectedValueEl = fieldset?.querySelector('.js-option-selected-value');
      if (selectedValueEl) {
        selectedValueEl.textContent = input.value;
      }
    });
  }
}

customElements.define('variant-radios', VariantRadios);

var AddToCart = class extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onButtonClick.bind(this));
    this.refresh = this.button.dataset.refresh == 'true' ? true : false;
    this.openCart = !this.refresh;
  }

  onButtonClick(event) {
    event.preventDefault();
    const id = this.button.dataset.id;
    let body = '';

    if (this.refresh) {
      body = JSON.stringify({
        items: [{
          id: id,
          quantity: 1
        }]
      });
    } else {
      body = JSON.stringify({
        items: [{
          id: id,
          quantity: 1
        }],
        sections: atcGetSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
    }

    addToCart(body, this.openCart, this.refresh);
  }
}

customElements.define('add-to-cart', AddToCart);

var ProductUpsell = class extends HTMLElement {
  constructor() {
    super();

    this.image = this.querySelector('.product-upsell__image img');
    this.button = this.querySelector('.product-upsell__button button')
    this.cartDrawer = document.querySelector('cart-drawer');

    // Swatches
    this.swatches = this.querySelectorAll('.product-upsell__swatch');
    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', this.onSwatchClick.bind(this));
    });
  }

  onSwatchClick() {
    event.preventDefault();
    
    this.updateActiveSwatch(event.target);
    this.updateImage(event.target);
    this.updateButton(event.target);
  }

  updateActiveSwatch(swatch) {
    this.swatches.forEach(swatch => {
      swatch.classList.remove('active');
    });

    swatch.classList.add('active');
  }

  updateImage(swatch) {
    const colorHandle = swatch.dataset.colorHandle;
    const color = swatch.dataset.color;

    if (colorHandle) {
      const imageContainers = this.querySelectorAll('.product-upsell__image .aspect-ratio');
      imageContainers.forEach(image => image.classList.remove('active'));

      this.querySelector(`.product-upsell__image .aspect-ratio.${colorHandle}`).classList.add('active');
      this.querySelector(`.product-upsell__image .aspect-ratio.${colorHandle} img`).setAttribute('alt', color);
    }
  }

  updateButton(swatch) {
    const id = swatch.dataset.id;

    if (id) {
      this.button.dataset.id = id;
    }
  }
}

customElements.define('product-upsell', ProductUpsell);

var DropdownItem = class extends HTMLElement {
  constructor() {
    super();

    this.parent = this.querySelector('.dropdown');
    this.header = this.querySelector('.dropdown-header');
    this.content = this.querySelector('.dropdown-content');

    this.header.addEventListener('click', this.onDropdownClick.bind(this));
  }

  onDropdownClick() {
    if (this.parent.classList.contains('active')) {
      this.hide();
    } else {
      this.deactivateAll();
      this.show();
    }
  }

  show() {
    this.parent.classList.add('active');
    slideDown(this.content, 200);
  }

  hide() {
    this.parent.classList.remove('active');
    slideUp(this.content, 200);
  }

  deactivateAll() {
    const allDropdownItems = document.querySelectorAll('dropdown-item');
    allDropdownItems.forEach((item) => {
      if (item === this) return;
      if (!item.parent.classList.contains('active')) return;

      item.hide();
    });
  }
}

customElements.define('dropdown-item', DropdownItem);

var SingleProduct = class extends HTMLElement {
  constructor() {
    super();

    this.swatches = this.querySelectorAll('.single-product__swatch');
    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', this.onSwatchClick.bind(this))
    })
  }

  onSwatchClick() {
    const id = event.currentTarget.dataset.id;

    // Handle swatch states
    this.querySelector('.single-product__swatch.active').classList.remove('active');
    event.currentTarget.classList.add('active');

    // Change active title
    this.querySelector('.single-product__active-swatch').innerHTML = event.currentTarget.dataset.title;

    // Update prices
    const prices = this.querySelectorAll('.price');
    prices.forEach(price => {
      const existingNewPrice = price.querySelector('.new-price');
      if (!existingNewPrice) {
        const originalPrice = document.createElement('span');
        originalPrice.classList.add('new-price');
        originalPrice.innerHTML = event.currentTarget.dataset.price;
        price.appendChild(originalPrice);
      }
      else{
        existingNewPrice.innerHTML = event.currentTarget.dataset.price;
      }
    })
    
    prices.forEach(stikeprice => {
    if (event.currentTarget.dataset.originalprice != '') {
      const existingOldPrice = stikeprice.querySelector('.old-price');
      if (!existingOldPrice) {
        const originalPrice = document.createElement('span');
        originalPrice.classList.add('old-price');
        originalPrice.innerHTML = event.currentTarget.dataset.originalprice;
        stikeprice.appendChild(originalPrice);
      }
      else{
        existingOldPrice.innerHTML = event.currentTarget.dataset.originalprice;
      }
    }
    })

    // Update links
    this.querySelector('.single-product__button').setAttribute('href', event.currentTarget.dataset.url);

    // Update ID
    this.querySelector('.single-product__atc').dataset.id = event.currentTarget.dataset.variant;

    // Update images
    this.querySelector('.single-product__image-group.active').classList.remove('active');
    this.querySelector(`.single-product__image-group[data-id="${id}"]`).classList.add('active');
  }
}

customElements.define('single-product', SingleProduct);
